
$(document).on('click', '.hk-element-sub-option:not(.hk-active)', function () {
  var $this = $(this);
  var tab = parseInt($this.attr('sub_tab'), 10); // 1,2,3...
  var selling_plan = parseInt($('.hk-element-option.hk-active').attr('selling_plan'), 10); // 1,2,3...
  if (!tab) return;
  // Remove active from siblings
  $('.hk-element-sub-option').removeClass('hk-active');
  // Add active to current
  $this.addClass('hk-active');
$('.hk-sub-trigger').hide();
$('.hk-sub-trigger[sub_tab="'+tab+'"]').show();
if (tab == 1){
$('.hk-checkout-button').attr('selling_plan',selling_plan);
$('.hk-AL-sec1-gift1-top .hk-element-title strong').text('Up to 61% Off');
} else {
$('.hk-checkout-button').removeAttr('selling_plan');
$('.hk-AL-sec1-gift1-top .hk-element-title strong').text('Up to 36% Off');
}
});
$(document).on('click', '.hk-element-sub-option.hk-active', function () {
$('.hk-element-sub-option:not(.hk-active)').trigger('click');
});



$(document).on('click', '.hk-element-option', function () {
  var $this = $(this);
  var quantity = parseInt($(this).attr('quantity'), 10); // 1,2,3...
  var selling_plan = parseInt($(this).attr('selling_plan'), 10); // 1,2,3...
  var sub_tab = parseInt($('.hk-element-sub-option.hk-active').attr('sub_tab'), 10); // 1,2,3...


  // Remove active from siblings
  $('.hk-element-option').removeClass('hk-active');

  // Add active to current
  $this.addClass('hk-active');

$('.hk-quantity-trigger').hide();
$('.hk-quantity-trigger[quantity="'+quantity+'"]').show();
$('.hk-checkout-button').attr('quantity',quantity);
if (sub_tab == 1){
$('.hk-checkout-button').attr('selling_plan',selling_plan);
} else {
$('.hk-checkout-button').removeAttr('selling_plan');
}

if(quantity > 1){
$('.hk-pdp-pdt-sub-heading1 em').text(quantity+' Scents to go');
} else {
$('.hk-pdp-pdt-sub-heading1 em').text(quantity+' Scent to go');
}
$('.hk-product-variant-right.hk-active input').each(function(){
$(this).val('0');
});
$('.hk-product-variant-right.hk-active').removeClass('hk-active');
update_step();
});



$(document).on("click", "a[href='#ingredients']", function (e) {
  e.preventDefault();
 $('.hk-pdp-popup').addClass('hk-active');
});


$(document).on("click", ".hk-pdp-popup-top .hk-icon-with-text-flex .hk-element-image", function (e) {
  e.preventDefault();
 $('.hk-pdp-popup').removeClass('hk-active');
});

$(document).on("click", "a[href='#']", function (e) {
  e.preventDefault();
  document.querySelector('.hk-product-flex').scrollIntoView({
    behavior: 'smooth'
  })
});




$(document).ready(async function () {

  const $deliveryEl = $('.hk-pdp-pdt-estimated');

  if (!$deliveryEl.length) return;

  // ===== Date 5 days ahead =====
  const futureDate = new Date();
  futureDate.setDate(futureDate.getDate() + 5);

  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  const formattedDate = `${months[futureDate.getMonth()]} ${futureDate.getDate()}, ${days[futureDate.getDay()]}`;

  // ===== Default location =====
  let locationText = 'Your Area';

  try {

    const res = await fetch('https://ipapi.co/json/');
    const data = await res.json();

    if (data) {
      const state = data.region || '';
      const country = data.country_name || '';

      if (state && country) {
        locationText = `${state}, ${country}`;
      } else if (country) {
        locationText = country;
      }
    }

  } catch (e) {

    console.log('Location fetch failed');

  }

  // ===== Replace placeholders =====
  let updatedHtml = $deliveryEl.html()
    .replace('[zipcode]', locationText)
    .replace('[stock_date]', formattedDate);

  $deliveryEl.html(updatedHtml);

});













$(document).on("click", ".hk-add-lp-cart-variant-js:not([disabled],.hk-disabled)", function(e) {
$(this).parents('.hk-product-variant-right').addClass('hk-active');
$(this).parents('.hk-product-variant-right').find('input').val('1').trigger('change');
});
$(document).on("change", ".hk-product-variant-right input", function(e) {
update_step();
});

$(document).on('click', '.hk-quantity-plus-lp-cart:not([disabled])', function () {
    const $wrapper = $(this).closest('.hk-product-variant-quantity-flex');
    const $input = $wrapper.find('.hk-lp-cart-quantity');

    let qty = parseInt($input.val(), 10) || 0;
    $input.val(qty + 1).trigger('change');
update_step();
});

$(document).on('click', '.hk-quantity-minus-lp-cart', function () {
    const $wrapper = $(this).closest('.hk-product-variant-quantity-flex');
    const $input = $wrapper.find('.hk-lp-cart-quantity');

    let qty = parseInt($input.val(), 10) || 0;

    if (qty > 0) {
        $input.val(qty - 1).trigger('change');
    }
    if (qty == 1) {
       $input.parents('.hk-product-variant-right').removeClass('hk-active');
    }
update_step();
});

function update_step() {
var required_quantity = parseInt($('.hk-element-option.hk-active').attr('quantity'));

var current_step = $('.hk-product-variants-selector');
var quantity = 0;
current_step.find('.hk-product-variant-right input').each(function(){
quantity = quantity + parseInt($(this).val());
});
current_step.find('.hk-lp-cart-top-step').removeClass('hk-active');
current_step.find('.hk-quantity-plus-lp-cart').removeAttr('disabled');
current_step.find('.hk-add-lp-cart-variant-js').removeAttr('disabled');

if(quantity == required_quantity){
$('.hk-checkout-button').removeAttr('disabled');
} else {
$('.hk-checkout-button').attr('disabled','disabled');
}
var pending_quantity = required_quantity - quantity;
if (pending_quantity > 1 ){
  $('.hk-pdp-pdt-sub-heading-number p em').text(pending_quantity+' Scents to go');
} else if (pending_quantity==1) {
  $('.hk-pdp-pdt-sub-heading-number p em').text(pending_quantity+' Scent to go');
} 

if(quantity == required_quantity){
$('.hk-pdp-pdt-sub-heading-number p em').text('All Scents Selected');
$('.hk-quantity-plus-lp-cart').attr('disabled','disabled');
$('.hk-add-lp-cart-variant-js').attr('disabled','disabled');
} else {
$('.hk-quantity-plus-lp-cart').removeAttr('disabled');
$('.hk-add-lp-cart-variant-js').removeAttr('disabled');
}




if(quantity >= 999){
current_step.find('.hk-quantity-plus-lp-cart').attr('disabled','disabled');
current_step.find('.hk-add-lp-cart-variant-js').attr('disabled','disabled');
}




}







function refreshCartDrawer_cart() {
  $.get(window.location.href, function (response) {
    var newContent = $(response).find('.hk-cart-drawer-js').html();
    $('.hk-cart-drawer-js').html(newContent);
    $('.hk-cart-drawer-js').removeClass('hk-loading-cart');
    document.querySelectorAll('.hk-element-related-grid.hk-slick-slider[data-slider-config]').forEach(slider => {
      const config = JSON.parse(slider.dataset.sliderConfig);

      if (!$(slider).hasClass('slick-initialized')) {
        $(slider).slick(config);
      }
    });
  });
  
}

$(document).ready(function(){
  
update_step();
});